var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt20 flex-box" },
    _vm._l(_vm.list, function (item) {
      return _c(
        "div",
        { key: item.paymentID, staticClass: "bj-row flex-box-item" },
        [
          _c("PaymentTable", {
            ref: "PaymentInfo",
            refInFor: true,
            attrs: { "row-data": item },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }